import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import EmptyList from 'primary/EmptyList';
import SymbolModal from 'primary/SymbolModal';

import Content from './Content';
import DataRange from './DataRange';

import { Else, If, Then, When } from 'react-if';

import './DataTab.scss';

const emptyArray = []
const DataTab = () => {
  const selectedSymbols = useSelector(state => state.seriesState.creatorState.selectedSymbols) || emptyArray,
        [isInfoModalOpen, setIsInfoModalOpen] = useState(false),
        [selectedSymbolIndex, setSelectedSymbolIndex] = useState(),
        swapIsInfoModalOpen = useCallback(() => setIsInfoModalOpen(isOpen => !isOpen), [])

  return (
    <div className="ng-office-app__authed__content__basket__body__data">
      <div className="ng-office-app__authed__content__basket__body__data__basket">
        <If condition={selectedSymbols.length === 0}>
          <Then>
            {() => (
              <EmptyList
                  subtitle="Add data in the series creator."
                  title="Basket is empty."
              />
            )}
          </Then>
          <Else>
            {() => (
              <Content
                  setSelectedSymbolIndex={setSelectedSymbolIndex}
                  swapIsInfoModalOpen={swapIsInfoModalOpen}
              />
            )}
          </Else>
        </If>
      </div>
      <DataRange/>
      <When condition={isInfoModalOpen}>
        {() => (
          <SymbolModal
              index={selectedSymbolIndex}
              onClose={swapIsInfoModalOpen}
          />
        )}
      </When>
    </div>
  )
}

export default DataTab;